import { Injectable } from "@angular/core";
import { StorageService } from "../../../session/services/storage.service";
import { COTECNA_USER_KEY } from "../../constants/constants";

@Injectable({
  providedIn: "root",
})
export class CustomTabsService {
  private readonly NL_PREFIX_ACCOUNT_NAME: string = "NL -";

  constructor(private storageService: StorageService) {}

  async getCustomTab(): Promise<{ position: number; tab: any }> {
    const user: any = await this.storageService.get(COTECNA_USER_KEY);
    if (user?.accountName?.startsWith(this.NL_PREFIX_ACCOUNT_NAME)) {
      return {
        position: 3,
        tab: {
          name: "Weight Determination",
          icon: "calculate",
          path: "calculations",
        },
      };
    }
  }
}
